export const fetchUserDetails = async () => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/users/details`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    })
}

export const fetchDashboardOrders = async () => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/dashboards/orders`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    })
}

export const updateUser = async (userId, data) => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/users/${userId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(data)
    })
}

export const forgotPassword = async (email) => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/forgot-password/${email}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const resetPassword = async (data) => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/reset-password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
}

export const logout = async (token) => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const getLastDatasetUpdateDate = async (token, datalensToken) => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/dataset/last-update-date`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            'datalens_token': datalensToken
        })
    })
}

export const generateDatalensToken = async (token) => {
    return fetch(`${process.env.VUE_APP_URL_DEV}/api/jwt/generate`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}
